import { Outlet } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import SkolkovoBanner from "./SkolkovoBanner";

export default function CSLayout() {

  return (
    <div>
      <Header/>
      <Outlet/>
      <Footer/>
      <SkolkovoBanner />
    </div>
  );
}
